export const GET_LABELS = 'GET_LABELS'
export const GET_LABEL = 'GET_LABEL'
export const ADD_LABEL = 'ADD_LABEL'
export const UPDATE_LABEL = 'UPDATE_LABEL'
export const DELETE_LABEL = 'DELETE_LABEL'
export const DELETE_ALL_LABELS = 'DELETE_ALL_LABELS'
export const GENERATE_STUDENT_LABEL_REPORT = 'GENERATE_STUDENT_LABEL_REPORT'
export const GENERATE_TEACHER_HOUSE_COLOR_REPORT = 'GENERATE_TEACHER_HOUSE_COLOR_REPORT'
